const content = [
  {
    header: 'AI Course & Quiz Builder',
    description:
      'Generate complete courses in seconds with AI-powered content creation',
    explanation:
      '<ul>' +
      '<li>• Complete courses with lessons, images, quizzes, forms and mini games.</li>' +
      '<li>• 20+ language support</li>' +
      '<li>• Start from PDFs or scratch</li>' +
      '<li>• Customize tone and audience</li>' +
      '</ul>',
    buttonText: 'Continue',
  },
  {
    header: 'AI Interaction Builder',
    description:
      'Turn static content into interactive learning experiences',
    explanation:
      '<ul>' +
      '<li>• Create scenarios, 3D models, and simulations</li>' +
      '<li>• Prompt-based creation</li>' +
      '<li>• Chat-based editing</li>' +
      '<li>• AI suggestions or start from scratch</li>' +
      '</ul>',
    buttonText: 'Continue',
  },
  {
    header: 'AI Games',
    description:
      'Turn course content into engaging games and puzzles like Crossword and Wordle.',
    explanation:
      '<ul>' +
      '<li>• Auto-generated from course content</li>' +
      '<li>• Multiple game formats for different learning styles</li>' +
      '<li>• Track learner performance with analytics</li>' +
      '<li>• Mobile-friendly gameplay for learning anywhere</li>' +
      '</ul>',
    buttonText: 'Continue',
  },
  {
    header: 'AI-Moderated Communities',
    description:
      'Build interactive learning communities with intelligent content moderation',
    explanation:
      '<ul>' +
      '<li>• Unlimited community boards</li>' +
      '<li>• AI auto-moderation in all languages</li>' +
      '<li>• AI summaries for long threads and sentiment analysis</li>' +
      '<li>• Smart permissions (reader, commenter, writer)</li>' +
      '</ul>',
    buttonText: 'Continue',
  },
  {
    header: 'Zero-friction Learner UX',
    description:
      'Simple, fast access for learners across all devices',
    explanation:
      '<ul>' +
      '<li>• Custom domain and landing pages</li>' +
      '<li>• Custom Certificates and badges</li>' +
      '<li>• Fully responsive for mobile interfaces</li>' +
      '<li>• Gateway options for different purposes (monetization, invitation-only, lead generation)</li>' +
      '</ul>',
    buttonText: 'Continue',
  },
  {
    header: 'Build Courses Over MCP',
    description:
      'Create courses without leaving your AI tool',
    explanation:
      '<ul>' +
      '<li>• Works with Claude, ChatGPT, Gemini and Cursor</li>' +
      '<li>• Build from Notion, Confluence, Slack or Drive</li>' +
      '<li>• Real courses with quizzes and interactions</li>' +
      '<li>• Update any course with one prompt</li>' +
      '</ul>',
    buttonText: 'Done 🎉',
  },
]

const CDN = 'https://cdn.minicoursegenerator.com/assets/onboarding/'

export const productTrainingContent = {
  'Branded Academy Website': [
    {
      header: 'Flexible Access Control',
      description:
        'Manage how users join: offer public enrollment, invite-only courses, or even paid access for exclusive content.',
      buttonText: 'Continue',
      image: CDN + 'branded_academy_website_1.png',
    },
    {
      header: 'Course Creation Made Easy',
      description:
        'Build interactive courses effortlessly with our drag-and-drop editor, including Image Hotspots, and AI Interaction Builder.',
      buttonText: 'Continue',
      image: { type: 'lottie', url: CDN + 'branded_academy_website_2.json' },
    },
    {
      header: 'Minutes to Launch',
      description:
        "Launch a high-converting academy page on your own domain without the overwhelming 'fluff' of traditional website builders.",
      buttonText: 'Continue',
      image: CDN + 'branded_academy_website_3.png',
    },
    {
      header: 'Certifications & Gamification',
      description:
        'Boost engagement with badges and rewards, and provide learners with verifiable certificates and unique credential links.',
      buttonText: 'Done 🎉',
      image: CDN + 'branded_academy_website_4.png',
    },
  ],
  'In-App Training Via Widgets': [
    {
      header: 'Minutes to Launch',
      description:
        'Just copy and paste a simple .js snippet into your front-end to activate in-app training.',
      buttonText: 'Continue',
      image: { type: 'lottie', url: CDN + 'widgets_1.json' },
    },
    {
      header: 'No Extra Login Required',
      description:
        'We handle the SSO automatically, providing a frictionless experience for your users.',
      buttonText: 'Continue',
      image: CDN + 'widgets_2.png',
    },
    {
      header: 'Native Look & Feel',
      description:
        'Choose from various UI layouts to make widgets look like a built-in feature of your product.',
      buttonText: 'Continue',
      image: CDN + 'widgets_3.png',
    },
    {
      header: 'Automated Data Sync',
      description:
        'Use webhooks to instantly connect user and course data to your CRM and other platforms.',
      buttonText: 'Done 🎉',
      image: CDN + 'widgets_4.png',
    },
  ],
  'In-App Training via Intercom': [
    {
      header: 'Keep Users in Your Product',
      description:
        'Stop sending users to external tabs or "knowledge graveyards." Deliver seamless, native education directly through Intercom Messenger.',
      buttonText: 'Continue',
      image: CDN + 'intercom_1.png',
    },
    {
      header: 'Just-in-Time Personalization',
      description:
        "Use Intercom's granular data and user attributes to trigger the right course at the exact moment in your dashboard.",
      buttonText: 'Continue',
      image: CDN + 'intercom_2.png',
    },
    {
      header: 'Course Creation Made Easy',
      description:
        'Build interactive courses effortlessly with our drag-and-drop editor, including an Intercom Article-to-Course Builder, Image Hotspots, and an AI Interaction Builder.',
      buttonText: 'Continue',
      image: CDN + 'intercom_3.png',
    },
    {
      header: 'Sync User Data with Automations',
      description:
        'Sync educational data, like completions and scores, directly to your CRM or trigger follow-up actions inside Intercom workflows.',
      buttonText: 'Done 🎉',
      image: CDN + 'intercom_4.png',
    },
  ],
  'In-App Training via APIs': [
    {
      header: 'Total Creative Control',
      description:
        "Build a completely bespoke training flow that matches your product's unique UX with our flexible REST APIs.",
      buttonText: 'Continue',
      image: CDN + 'api_1.png',
    },
    {
      header: 'No Extra Login Required',
      description:
        'We handle the SSO automatically, providing a frictionless, "stay-logged-in" experience for your users.',
      buttonText: 'Continue',
      image: CDN + 'api_2.png',
    },
    {
      header: 'Mobile-Native Integration',
      description:
        'The perfect solution for native mobile-apps, and web apps. Deliver interactive courses seamlessly within your native mobile environment.',
      buttonText: 'Continue',
      image: CDN + 'api_3.png',
    },
    {
      header: 'Straightforward Implementation',
      description:
        'Get up and running quickly with developer-friendly API documentation and dedicated technical support.',
      buttonText: 'Done 🎉',
      image: CDN + 'api_4.png',
    },
  ],
}

export const sellingContent = {
  'Selling to Individual Learners': [
    {
      header: 'No Commissions, No Delays',
      description:
        'We take 0% of your sales. Payments go directly to your connected account, ensuring you keep every cent you earn.',
      buttonText: 'Continue',
      image: { type: 'lottie', url: CDN + 'individual_1.json' },
    },
    {
      header: 'Prevent "Free-Riders"',
      description:
        'Protect your revenue with secure, non-sharable magic links that expire after use to prevent unauthorized access.',
      buttonText: 'Continue',
      image: CDN + 'individual_2.png',
    },
    {
      header: 'Create High-Converting Landing Pages',
      description:
        'Launch a branded website on your own custom domain to showcase your paid, invite-only, and public courses in one unified site.',
      buttonText: 'Continue',
      image: CDN + 'individual_3.png',
    },
    {
      header: 'Interactive Course Creation Made Easy',
      description:
        'Build interactive courses effortlessly with our drag-and-drop editor and standout features like our PDF-to-Course creator, AI Interaction, and AI Edu-game Builders.',
      buttonText: 'Done 🎉',
      image: { type: 'lottie', url: CDN + 'individual_4.json' },
    },
  ],
  'Selling to Organizations': [
    {
      header: 'Control Access Duration',
      description:
        "Revoke access instantly for any uploaded learner list. Even if you export courses in SCORM for a client's LMS, you can disable access at any time thanks to its dynamic format.",
      buttonText: 'Continue',
      image: CDN + 'orgs_1.png',
    },
    {
      header: 'Interactive Course Creation Made Easy',
      description:
        'Build interactive courses effortlessly with our drag-and-drop editor and standout features like our PDF-to-Course creator, AI Interaction, and AI Edu-game Builders.',
      buttonText: 'Continue',
      image: { type: 'lottie', url: CDN + 'orgs_2.json' },
    },
    {
      header: 'Provide Detailed Reporting',
      description:
        'Deliver granular analytics to your clients. Share completion and success data at both learner and course levels, including every individual answer.',
      buttonText: 'Continue',
      image: CDN + 'orgs_3.png',
    },
    {
      header: 'Certifications & Gamification',
      description:
        'Boost engagement with badges and rewards, and provide learners with verifiable certificates and unique credential links.',
      buttonText: 'Done 🎉',
      image: CDN + 'orgs_4.png',
    },
  ],
  'Selling Certification & Credentials': [
    {
      header: 'Monetize Verified Knowledge',
      description:
        'Offer courses for free, then require payment for verified certificates. Set success thresholds to ensure learners deserve their credentials.',
      buttonText: 'Continue',
      image: CDN + 'cert_1.png',
    },
    {
      header: 'Verifiable Digital Credentials',
      description:
        'Provide shareable certificate links with unique IDs that can be instantly verified by employers and shared on LinkedIn directly.',
      buttonText: 'Continue',
      image: CDN + 'cert_2.png',
    },
    {
      header: 'Launch a Branded Academy',
      description:
        'Build a professional, branded destination for your certifications on your own custom domain. Zero technical setup required.',
      buttonText: 'Continue',
      image: CDN + 'cert_3.png',
    },
    {
      header: 'Automated Delivery & Revenue',
      description:
        'Automate the entire journey from payment to certificate generation. Keep 100% of your earnings with 0% commissions on all sales.',
      buttonText: 'Done 🎉',
      image: CDN + 'cert_4.png',
    },
  ],
}

export const eLearningContent = [
  {
    header: 'The simplicity. Literally.',
    description:
      'Creating interactive and visually aesthetic courses has never been easier with our drag & drop editor and its rich set of blocks.',
    buttonText: 'Continue',
    image: CDN + 'e-learning_1.png',
  },
  {
    header: 'Let AI do the heavy-lifting.',
    description:
      'Just upload your source, set your preferences, and get a structured course with built-in assessments and educational games.',
    buttonText: 'Continue',
    image: CDN + 'e-learning_2.png',
  },
  {
    header: 'Use AI for interactive e-learning.',
    description:
      'Videos and slides are static. Instead, use our AI Interaction Builder to turn text into contextually meaningful interactive elements with editing options.',
    buttonText: 'Continue',
    image: { type: 'lottie', url: CDN + 'e-learning_3.json', loop: false },
  },
  {
    header: 'Create & edit interactivity easily.',
    description:
      'Use various interactive content block options like image hotposts, clickable carousels, accordions, etc. for lesson pages in the exact way you want.',
    buttonText: 'Continue',
    image: { type: 'lottie', url: CDN + 'e-learning_4.json', loop: false },
  },
  {
    header: 'The nest for e-learning curation.',
    description:
      'Enrich your courses with various e-learning elements like embedding Spotify audio, Canva visuals, Synthesia avatars, and more.',
    buttonText: 'Done 🎉',
    image: { type: 'lottie', url: CDN + 'e-learning_5.json', loop: false },
  },
]

// ---------------------------------------------------------------------------
// Curated decks for the redesigned Q2 answers. Each new answer reuses the most
// relevant individual cards cherry-picked from the decks above (not whole
// decks), composed by reference so the source cards stay unchanged. Customer
// Success answers are looked up in productTrainingContent; Creator answers in
// sellingContent (see onboarding-information.js). Card IDs in comments match
// the onboarding card library.
// ---------------------------------------------------------------------------
const _ptBAW = productTrainingContent['Branded Academy Website']
const _ptWidgets = productTrainingContent['In-App Training Via Widgets']
const _ptApis = productTrainingContent['In-App Training via APIs']
const _scIndividual = sellingContent['Selling to Individual Learners']
const _scOrgs = sellingContent['Selling to Organizations']
const _scCerts = sellingContent['Selling Certification & Credentials']

// Customer Success & Product Training — "What type of product or service do you offer?"
productTrainingContent['B2B SaaS / Software'] = [_ptApis[0], _ptWidgets[1], _ptApis[3], _ptWidgets[3]] // API1 W2 API3 W4
productTrainingContent['B2C SaaS / Mobile App'] = [_ptApis[2], _ptApis[0], _ptWidgets[2], _ptApis[3]] // API2 API1 W3 API3
productTrainingContent['Physical / Hardware Product'] = [_ptBAW[0], _ptBAW[1], _ptBAW[3], _scCerts[2]] // BA1 BA2 BA3 SC3
productTrainingContent['Professional Services & Consulting'] = [_ptBAW[1], _scCerts[0], _scOrgs[2], _ptBAW[0]] // BA2 SC1 SO2 BA1

// Creator / Solopreneur — "How do you plan to deliver or monetize your content?"
sellingContent['Selling paid courses & certifications'] = [_scIndividual[0], _scIndividual[2], _scCerts[1], _scIndividual[3]] // SI1 SI3 SC2 SI4
sellingContent['Free lead magnet / audience growth'] = [eLearningContent[1], eLearningContent[2], _scIndividual[2], eLearningContent[4]] // EL2 EL3 SI3 EL5
sellingContent['Client onboarding / coaching material'] = [_ptBAW[0], _scOrgs[0], _scOrgs[2], _scIndividual[3]] // BA1 SO1 SO2 SI4

// Marketing & Community — "What is your primary goal with your content?"
// (looked up by INTEREST.MARKETING_COMMUNITY in onboarding-information.js)
export const marketingContent = {
  'Lead generation & lead nurturing': [_scIndividual[2], eLearningContent[2], _ptBAW[0], _ptWidgets[3]], // SI3 EL3 BA1 W4
  'Educating an open community / forum': [_ptBAW[0], eLearningContent[2], eLearningContent[4], _ptBAW[3]], // BA1 EL3 EL5 BA3
  'Event or webinar participant enablement': [_scOrgs[0], eLearningContent[2], _ptBAW[0], _scOrgs[2]], // SO1 EL3 BA1 SO2
}

// ---------------------------------------------------------------------------
// MCP / agentic card, appended as the closing slide of every curated deck.
// Art is taken from the agentic-lms marketing page, re-encoded as webp and
// hosted on the onboarding CDN alongside the other card images.
// ---------------------------------------------------------------------------
// MCP card art. Served from the admin app's own /assets like the generic deck's
// images, so there is no CDN or marketing-site dependency. Re-cropped to 1120x720
// (ratio 1.556) to match slideImageCard exactly, like all the other curated art.
const MCP_CREATE = '/assets/mcp-create.webp' // prompt -> finished course
const MCP_LOCALIZE = '/assets/mcp-localize.webp' // clone + translate a course
const MCP_ANALYTICS = '/assets/mcp-analytics.webp' // learner results dashboard

const mcpCard = (header, description, image) => ({
  header,
  description,
  buttonText: 'Done 🎉',
  image,
})

// Customer Success & Product Training
productTrainingContent['B2B SaaS / Software'].push(
  mcpCard('MCP Turns Docs Into Courses',
    'Ask Claude or ChatGPT to turn your product docs into a full course. It keeps everything it already knows about your product as it writes.',
    MCP_CREATE))
productTrainingContent['B2C SaaS / Mobile App'].push(
  mcpCard('MCP Shows Where Users Stall',
    'Ask your assistant how learners performed, then have it reword the confusing lessons and harden the questions everyone aces.',
    MCP_ANALYTICS))
productTrainingContent['Physical / Hardware Product'].push(
  mcpCard('MCP Localizes for Every Market',
    'Clone your setup course and translate it for each market you ship to, in a single prompt.',
    MCP_LOCALIZE))
productTrainingContent['Professional Services & Consulting'].push(
  mcpCard('MCP Packages Your Expertise',
    'Point your assistant at existing decks, notes and client docs, and it returns a structured course you can reuse.',
    MCP_CREATE))

// Creator / Solopreneur
sellingContent['Selling paid courses & certifications'].push(
  mcpCard('Create in Your AI Tool via MCP',
    'Build and publish courses straight from Claude or ChatGPT, complete with quizzes and interactive blocks.',
    MCP_CREATE))
sellingContent['Free lead magnet / audience growth'].push(
  mcpCard('MCP Turns Docs Into Lead Magnets',
    'Point your assistant at a blog post or guide and it returns a finished interactive course you can gate.',
    MCP_CREATE))
sellingContent['Client onboarding / coaching material'].push(
  mcpCard('One MCP Prompt, Every Client',
    'Clone your onboarding course for each client and translate it, without rebuilding it every time.',
    MCP_LOCALIZE))

// Marketing & Community
marketingContent['Lead generation & lead nurturing'].push(
  mcpCard('Lead Magnets in One MCP Prompt',
    'Describe the topic and your assistant drafts the course, quizzes and interactions, ready to publish.',
    MCP_CREATE))
marketingContent['Educating an open community / forum'].push(
  mcpCard('MCP Localizes for Your Community',
    'Ask your assistant to clone and translate any course so your community can learn in its own language.',
    MCP_LOCALIZE))
marketingContent['Event or webinar participant enablement'].push(
  mcpCard('MCP Shows Who Actually Engaged',
    'Pull attendance, completion and quiz scores in one prompt, then follow up with the people who stalled.',
    MCP_ANALYTICS))

export default content
